require('./amazonGiftCardReedemptionSteps.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText,formatText } = require('core/i18n').i18n;
const infoIcon = require('assets/images/icon-info-blue.svg'); //@hardcoded: replace Icon placeholder
// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
// @commons
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

class AmazonGiftCardReedemptionSteps extends React.Component {

    render(){
        const {showHorizontalSteps} = this.props;
        const list =  ['reedemCardStep1', 'reedemCardStep2', 'reedemCardStep3' ];
        const elements = list.map((item, index) => {
            return (
                <li className="accounts-buy-amazon-gift-card-reedemption-steps__list-item" key={`element-${index}`}>
                    <FormattedText
                        className="accounts-buy-amazon-gift-card-reedemption-steps__list-item-value"
                        value={`buyAmazonGiftCard-${item}`}
                    />
                </li>
            );
        });

        const boxTitle = formatText('buyAmazonGiftCard-reedemCardTitle');
        const boxBody = (
            <div>
                <div className="accounts-buy-amazon-gift-card-reedemption-steps__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <ol className="accounts-buy-amazon-gift-card-reedemption-steps__list">
                    {elements}
                </ol>
            </div>
        );

        let reedemptionSteps;
        if(showHorizontalSteps) {
            reedemptionSteps = (
                <ContactInfoBox
                    boxTitle={boxTitle}
                    boxBody={boxBody}
                    icon={infoIcon}
                />
            );
        } else {
            reedemptionSteps = (
                <div>
                    <h4 className="accounts-buy-amazon-gift-card-reedemption-steps__title"> {boxTitle} </h4>
                    <ol className="accounts-buy-amazon-gift-card-reedemption-steps__list">
                        {elements}
                    </ol>
                </div>
            )
        }

        return(
            <div className="accounts-buy-amazon-gift-card-reedemption-steps">
                {reedemptionSteps}
            </div>
        );
    }
}

AmazonGiftCardReedemptionSteps.propTypes = {
    showHorizontalSteps: PropTypes.bool,
}

AmazonGiftCardReedemptionSteps.defaultProps = {
    showHorizontalSteps: true
}

module.exports = AmazonGiftCardReedemptionSteps;
